import { z } from "zod";

// LINE 送信ログ / Push 配信統計 (F22)。送信自体は F13 の通知dispatcherが担い、
// 読取専用の `line` ルーター (pushStats / sendLogs) がこのschemaを利用する。

export const LineSendStatus = z.enum(["pending", "sent", "delivered", "failed"]);

export const LineSendLog = z
  .object({
    notification_type: z.string(),
    title: z.string(),
    recipient_name: z.string().nullable(),
    status: LineSendStatus,
    sent_at: z.iso.datetime({ offset: true }).nullable(),
    delivered_at: z.iso.datetime({ offset: true }).nullable(),
    fail_reason: z.string().nullable(),
    created_at: z.iso.datetime({ offset: true }),
  })
  .strict();

export const ListLineSendLogsInput = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(50),
  cursor: z.string().optional(),
});

export const LinePushDailyCount = z.object({
  date: z.string(),
  count: z.number().int(),
});

export const LinePushCategoryCount = z.object({
  category: z.string(),
  count: z.number().int(),
});

export const LinePushStats = z.object({
  month: z.string(),
  total_count: z.number().int(),
  limit: z.number().int(),
  remaining: z.number().int(),
  daily_counts: z.array(LinePushDailyCount),
  by_category: z.array(LinePushCategoryCount),
});

export const GetLinePushStatsInput = z.object({
  month: z
    .string()
    .regex(/^\d{4}-(0[1-9]|1[0-2])$/)
    .optional(),
});

export type LineSendLogDto = z.infer<typeof LineSendLog>;
export type ListLineSendLogsInputDto = z.infer<typeof ListLineSendLogsInput>;
export type LinePushStatsDto = z.infer<typeof LinePushStats>;
export type GetLinePushStatsInputDto = z.infer<typeof GetLinePushStatsInput>;
